import {
    AuthFlowType,
    InitiateAuthCommand,
    RespondToAuthChallengeCommand,
    SignUpCommand,
    CognitoIdentityProviderClient,
    GetUserCommand,
    GlobalSignOutCommand
} from '@aws-sdk/client-cognito-identity-provider';

const cognitoClient = new CognitoIdentityProviderClient({region: 'us-east-1'});
const challengeName = 'CUSTOM_CHALLENGE';

export default class AwsCognito {
    private userSession?: string;
    private readonly cognitoConfig: any;
    private userPool: any;
    constructor(config: any) {
        this.userSession = undefined;
        this.cognitoConfig = config;
        this.configure(this.cognitoConfig)
    }

    configure (config: any) {

    }

    setSession(userSession: string) {
        this.userSession = userSession
    }

    async signup(username: string, fullName: string, email: string, pass: string, config: string, configId: number, roldId: string) {
        const command = new SignUpCommand({
            ClientId: this.cognitoConfig.ClientId,
            Username: username,
            Password: pass,
            UserAttributes: [
                { 'Name': 'email', 'Value': email},
                { 'Name': 'name', 'Value': fullName },
                { 'Name': 'custom:configName', 'Value': config },
                { 'Name': 'custom:configId', 'Value': configId.toString() },
                { 'Name': 'custom:roleId', 'Value': roldId }
            ],
            UserContextData: {}
        });
        return await cognitoClient.send(command);
    }

    async authenticate (username: string, pass: string) {
        const command = new InitiateAuthCommand({
            ClientId: this.cognitoConfig.ClientId,
            AuthFlow: AuthFlowType.CUSTOM_AUTH,
            AuthParameters: {
                USERNAME: username,
                PASSWORD: pass,
            }
        });
        const response = await cognitoClient.send(command);
        this.userSession = response.Session
        return response
    }

    async respondToAuthChallenge(username: string, code: string) {
        const input = {
            ClientId: this.cognitoConfig.ClientId,
            ChallengeName: challengeName,
            ChallengeResponses: {
                'USERNAME': username,
                'ANSWER': code
            },
            Session: this.userSession
        };
        const command = new RespondToAuthChallengeCommand(input);
        const response = await cognitoClient.send(command);
        return [response.AuthenticationResult.AccessToken, response.AuthenticationResult.RefreshToken, response.AuthenticationResult.IdToken]
    }

    async getCurrentUser(accessToken: string) {
        const input = {
            AccessToken: accessToken,
        };
        const command = new GetUserCommand(input);
        return await cognitoClient.send(command);
    }

    async logoutCurrentUser (accessToken: string) {
        const input = {
            AccessToken: accessToken,
        };
        const command = new GlobalSignOutCommand(input);
        return await cognitoClient.send(command);
    }
}
